import Markdown from 'components/markdown';
import renderDocument from 'modules/content-cms/util/render-document';
import React from 'react';
import Button from '../../../../components/button';
import { ISectionEducationalDiscountFields } from '../../../../global';

const EducationalDiscount: React.FC<ISectionEducationalDiscountFields> = ({
  title,
  buttonText,
  buttonLink,
  bodyText,
}) => {
  return (
    <div className="relative mx-auto mt-2 px-6">
      <div className="mx-auto mt-8 flex max-w-lg flex-col rounded-lg border-2 border-primary-main bg-grey-50">
        <img
          src="/images/petsdeli-logo.svg"
          className="absolute -top-8 -mb-16 -ml-4 h-16 w-auto"
          alt="Pets Deli"
          role="presentation"
        />
        <div className="m-4">
          <h3 className="mt-4 text-lg font-black text-primary-main">
            {title}
          </h3>

          <Markdown className="pb-2 text-primary-main">
            {renderDocument(bodyText)}
          </Markdown>

          <Button href={buttonLink} layout={'brand'} className="w-full">
            {buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EducationalDiscount;
